import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import selectOptions from '../../../text/selectOptions';
import { PhoneField, SelectField, TextField } from './../../../components/fields';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../../text/messages';
import { required, email, errorMessages } from '../../../utilities/validation';
import { autoFooler } from '../../../utilities/string';

import WizardButtons from '../../../components/wizard/navigator/buttons';
import FieldGenerator from '../../../components/fields/generator';
import { getFormTypeQuestions } from '../../../reducers/formInstances';
import { savePosition, getPosition } from '../../../reducers/positions';
import { setProgress } from '../../../reducers/wizard';
import { parseAnswers, answersToInitialValues } from '../../../utilities/formInstances';
import Modal from '../../../components/modal';

import './steps.css';

class PositionTheWorkerStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            isModalOpenIConly: false
        };
        this.submit = this.submit.bind(this);
        this.getClientQuestions = this.getClientQuestions.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onCloseIConly = this.onCloseIConly.bind(this);
        this.classificationOptions = this.classificationOptions.bind(this);
    }

    submit(values) {
        const { position, questions, savePosition, classify_client_pref, getPosition, next, branch, setProgress } = this.props;
        let answers = parseAnswers(null, questions, values);

        let data = { ...position, classify_client_pref, classify_client_answers: { answers } };

        setProgress({ id: position.id, entity: 'position' }, { ...(position.progress || {}), step: 2, branch, worker: values }, () => {
            savePosition(data, () => {
                getPosition(data.id, true, res => {
                    if (classify_client_pref === 'ic-preferred' && res.classify_client_result === 'w2-only') {
                        this.setState({ isModalOpen: true });
                    } else if (classify_client_pref === 'ic-only' && res.classify_client_result === 'w2-only') {
                        this.setState({ isModalOpenIConly: true });
                    } else {
                        next(4, position.id, branch);
                    }
                });
            });
        });
    }

    getClientQuestions() {
        const { initialValues, userDetails, getFormTypeQuestions, position } = this.props;
        const { id } = initialValues;

        const formType = 'job_classification_client';

        if (id) {
            getFormTypeQuestions(formType, userDetails.admin_id, position.id);
        }
    }

    onClose() {
        const { next, position, branch } = this.props;
        this.props.change('classify_client_pref', 'w2-only');
        this.setState({ isModalOpen: false });
        next(3, position.id, branch);
    }

    onCloseIConly() {
        const { next, position, branch } = this.props;
        this.setState({ isModalOpenIConly: false });
        next(2, position.id, branch);
    }

    componentDidMount() {
        this.getClientQuestions();
    }

    componentDidUpdate() {
        this.getClientQuestions();
    }

    classificationOptions() {
        const { admin, details, position } = this.props;
        const { job_policies } = details;
        const options = selectOptions.getClassificationPrefs(admin);

        if (position.country === 'UK') return options.filter(o => o.value === 'w2-or-ic');

        if (job_policies) {
            if (job_policies.w2_only) return options.filter(o => o.value === 'w2-only');
            if (job_policies.ic_only) return options.filter(o => o.value === 'ic-only');
        }
        return options;
    }

    renderModalICpreferred() {
        return (
            <Modal
                open={this.state.isModalOpen}
                onClose={this.onClose}
                managedClose
                size="col-sm-8 col-sm-offset-2 col-xs-12"
                title={<FormattedMessage {...messages.incompatibleTitle} />}
            >
                <div className="row modal-row-short">
                    <FormattedHTMLMessage {...messages.incompatibleMessage} tagName="p" />
                </div>
                <div className="row modal-row">
                    <button onClick={this.onClose} className="modal-button">
                        <FormattedMessage {...messages.continue} />
                    </button>
                </div>
            </Modal>
        );
    }

    renderModalIConly() {
        const { details: client } = this.props || {};
        const { job_policies } = client || {};
        const yourPlanB = job_policies && job_policies.ic_only ? messages.incompatibleMessageIConlyPolicy : messages.incompatibleMessageIConlyChangeW2;
        return (
            <Modal
                open={this.state.isModalOpenIConly}
                onClose={this.onCloseIConly}
                managedClose
                size="col-sm-8 col-sm-offset-2 col-xs-12"
                title={<FormattedMessage {...messages.incompatibleTitle} />}
            >
                <div className="row modal-row-short">
                    <FormattedHTMLMessage {...messages.incompatibleMessageIConly} tagName="p" />
                    <FormattedHTMLMessage {...yourPlanB} tagName="p" />
                </div>
                <div className="row modal-row">
                    <button onClick={this.onCloseIConly} className="modal-button">
                        <FormattedMessage {...messages.ok} />
                    </button>
                </div>
            </Modal>
        );
    }

    render() {
        const { handleSubmit, back, cancel, submitting, questions, classify_client_pref, client_name, position } = this.props;
        const areQuestionsDisabled = classify_client_pref === 'w2-only';
        if (!questions) {
            return null;
        }
        return (
            <div>
                <form onSubmit={handleSubmit(values => this.submit(values))}>
                    <div className="row">
                        <div className="col-xs-12 col-md-5 col-lg-4">
                            <Field
                                name="first_name"
                                component={TextField}
                                autoComplete={autoFooler('firstName')}
                                validate={required}
                                placeholder={messages.firstName}
                            />
                        </div>
                        <div className="col-xs-12 col-md-5 col-lg-4">
                            <Field
                                name="last_name"
                                component={TextField}
                                autoComplete={autoFooler('lastName')}
                                validate={required}
                                placeholder={messages.lastName}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-5 col-lg-4">
                            <Field
                                name="email"
                                component={TextField}
                                validate={[required, email]}
                                autoComplete={autoFooler('workerEmail')}
                                placeholder={messages.workerEmail}
                            />
                        </div>
                        <div className="col-xs-12 col-md-5 col-lg-4">
                            <Field
                                name="phoneNumber"
                                component={PhoneField}
                                placeholder={messages.phoneNumber}
                                validate={required}
                                autoComplete={autoFooler('phone')}
                                country={position.country}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-5 col-lg-4">
                            <Field
                                name="classify_client_pref"
                                validate={required}
                                component={SelectField}
                                options={this.classificationOptions()}
                                placeholder={messages.classifyClientPreference}
                            />
                        </div>
                        {classify_client_pref !== 'w2-only' && (
                            <div className="col-xs-12 col-md-5 col-lg-4">
                                <Field
                                    name="dbaName"
                                    component={TextField}
                                    placeholder={position.country === 'UK' ? messages.lcNameOptional : messages.dbaNameOptional}
                                    autoComplete={autoFooler('dba')}
                                    disabled={classify_client_pref === 'w2-only'}
                                />
                            </div>
                        )}
                    </div>

                    <div className="row">
                        <div className={`col-xs-12 col-md-10 col-lg-8 ${areQuestionsDisabled ? 'disabled-questions' : ''}`}>
                            {questions.map((d, i) => (
                                <FieldGenerator disabled={areQuestionsDisabled} key={i} definition={d} client_name={client_name} formName={'position-wizard'} />
                            ))}
                        </div>
                    </div>

                    <WizardButtons disabled={submitting} back={{ action: back }} cancel={{ action: cancel }} />
                </form>
                {this.renderModalICpreferred()}
                {this.renderModalIConly()}
            </div>
        );
    }
}

PositionTheWorkerStep = reduxForm({
    form: 'position-wizard',
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true,
    validate: (values, props) => {
        if (props.questions && values.classify_client_pref !== 'w2-only') {
            return props.questions.reduce((errors, q) => {
                if (!(q.id in values)) {
                    errors[`${q.id}`] = { value: errorMessages.required() };
                }
                return errors;
            }, {});
        }
    }
})(PositionTheWorkerStep);

const selector = formValueSelector('position-wizard');
const mapStateToProps = (state, props) => {
    const { worker } = props.position.progress || {};
    const { client_name } = props.position || {};

    const questionAnswers =
        props.position && props.position.classify_client_answers ? answersToInitialValues(props.position.classify_client_answers.answers) : {};
    const classify_client_pref = selector(state, 'classify_client_pref');
    const userDetails = state.identity.details || {};
    const initClassifyPref = (userDetails.job_policies || {}).w2_only ? { classify_client_pref: 'w2-only' } : {};

    let initialValues = {
        ...props.initialValues,
        ...props.position,
        ...questionAnswers,
        ...(worker || {}),
        ...initClassifyPref
    };

    return {
        admin: state.users.adminDetails,
        userDetails,
        questions: state.formInstances.questions,
        classification: state.formInstances.classification,
        classify_client_pref,
        client_name,
        initialValues
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            savePosition,
            getPosition,
            getFormTypeQuestions,
            setProgress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PositionTheWorkerStep);



// WEBPACK FOOTER //
// ./src/pages/position/steps/positionTheWorker.jsx